/* Mega menu with collection cards.
   - Desktop: opens the panel on hover (click still works, it is a <details>).
   - Drawer: turns the parent item into a plain accordion instead of Dawn's
     slide-in submenu.
   Paired with snippets/header-mega-cards.liquid + component-mega-cards.css. */
(function () {
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 140;

  /* ------------------------------- Desktop ------------------------------- */
  function initDesktop(scope) {
    scope.querySelectorAll('[data-mega-menu]').forEach(function (details) {
      if (details.dataset.megaInit === 'true') return;
      details.dataset.megaInit = 'true';

      var host = details.closest('header-menu') || details;
      var closeTimer = null;

      host.addEventListener('mouseenter', function () {
        if (!HOVER.matches) return;
        clearTimeout(closeTimer);
        if (!details.open) details.open = true;
      });

      host.addEventListener('mouseleave', function () {
        if (!HOVER.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.open = false;
        }, CLOSE_DELAY);
      });

      // Following a card should not leave the panel hanging open behind the
      // new page in browsers that restore the details state.
      details.addEventListener('click', function (event) {
        if (event.target.closest('a')) details.open = false;
      });
    });
  }

  function closeAllPanels(event) {
    document.querySelectorAll('[data-mega-menu][open]').forEach(function (details) {
      if (event && details.contains(event.target)) return;
      details.open = false;
    });
  }

  /* -------------------------------- Drawer -------------------------------- */
  function initDrawer(scope) {
    scope.querySelectorAll('header-drawer').forEach(function (drawer) {
      if (drawer.dataset.megaAccInit === 'true') return;
      drawer.dataset.megaAccInit = 'true';

      // Dawn's MenuDrawer binds every <summary> in the drawer and slides a
      // submenu panel in. Catching the click here, on the way down, keeps that
      // handler from running while leaving the native <details> toggle alone.
      drawer.addEventListener(
        'click',
        function (event) {
          var summary = event.target.closest && event.target.closest('[data-mega-accordion-summary]');
          if (summary && drawer.contains(summary)) event.stopPropagation();
        },
        true
      );
    });
  }

  /* --------------------------------- Init --------------------------------- */
  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    initDesktop(root);
    initDrawer(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-mega-menu]')) closeAllPanels(event);
  });

  document.addEventListener('keyup', function (event) {
    if (event.code === 'Escape') closeAllPanels();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
